<template>
    <ul>
        <li> <router-link to="/help/article/write">記事を書く</router-link> </li>
        <li> <router-link to="/help/article/link">外部記事をリンクする</router-link> </li>
        <li> <router-link to="/help/article/publish">記事の公開について</router-link> </li>
        <li> <router-link to="/help/article/example">記事の使い方</router-link> </li>
    </ul>
</template>
